import { createContext } from 'react';
export const TransitionPaletteContext = createContext(false);
